export default __webpack_public_path__ + "static/media/goods9.d24fb473.gif";